import { setupCache, RedisDefaultStore } from 'axios-cache-adapter';
import { conversationService } from '../modules/conversations/services/ConversationService';
import { profileService } from '../modules/profile/services/ProfileService';
import { categoryService } from '../modules/category/services/CategoryService';
import { tagService } from '../modules/tag/services/TagService';
import { instagramService } from '../modules/instagram/services/InstagramService';
import { searchService } from '../modules/search/services/SearchService';
import { notificationService } from '../modules/notifications/services/NotificationService';
import { feedbackService } from '../modules/feedback/services/FeedbackService';
import { corporateService } from '../modules/corporate/services/CorporateService';
import { yazioService } from '../modules/yazio/services/YazioService';
import { vitrinService } from '../modules/vitrin/services/VitrinService';
import { articleService } from '../modules/article/services/ArticleService';
import { homePageService } from '../modules/homepage/services/HomePageService';
import { authService } from '../modules/auth/services/AuthService';
import { userService } from '../modules/profile/services/UserService';
import { configService } from '../modules/config/services/ConfigService';
import { getRedisKeyPrefix } from '../modules/config/configUtils';
import { gameService } from '~/modules/oyun/services/GameService';
import { STN_LAMBDA_URL } from '~/constants/config';
import { discoverService } from '~/modules/kesfet/services/DiscoverService';
import { cookieKey } from '~/modules/common/utils/cookieUtils';
/**
 * Service provider
 * @info Nuxt instance'a dışardan erişilemiyor henüz(v2). nuxt v3 gelince tekrar irdelenecek.
 */

const createService = ({ app, $axios, redirect, $cookies, $sentry, ...context }, inject) => {
  $axios.defaults.timeout = 5000;
  $axios.onError(async (error) => {
    // send reco error to sentry
    const url = error?.config?.url || '';
    if (url.includes(STN_LAMBDA_URL)) {
      $sentry.captureException(error);
    }
    // get new token and retry request
    const originalRequest = error.config;
    const isLoginRequest = originalRequest.url.includes('/auth/login');
    if (error.response && error.response.status === 401 && !originalRequest._retry && !isLoginRequest) {
      // refresh token request is not allowed
      if (originalRequest.url.includes('/auth/token')) {
        $cookies.remove(cookieKey.REFRESH_TOKEN);
        return Promise.reject(error);
      }
      originalRequest._retry = true;
      try {
        $cookies.remove(cookieKey.AUTH_TOKEN);
        // get new token with refresh token
        const { data } = await authService($axios, $cookies).refreshToken();
        // set auth token and refresh token
        $cookies.set(cookieKey.AUTH_TOKEN, data.authToken, {
          path: '/',
          maxAge: 60 * 60 * 24 * 30, // 30 gün
        });
        $cookies.set(cookieKey.REFRESH_TOKEN, data.refreshToken, {
          path: '/',
          maxAge: 60 * 60 * 24 * 60, // 60 gún
        });
        originalRequest.headers.Authorization = `Bearer ${data.authToken}`;
        return $axios(originalRequest);
      } catch (refreshTokenError) {
        console.log('refreshTokenError', refreshTokenError);
        return Promise.reject(refreshTokenError);
      }
    }
    return Promise.reject(error);
  });

  const redisClient = context?.ssrContext?.$axCache;
  const cache = setupCache({
    debug: false,
    store: redisClient ? new RedisDefaultStore(redisClient, { prefix: getRedisKeyPrefix() + ':' }) : null,
    exclude: {
      query: false,
    },
    excludeFromCache: true,
  });

  const cachedAxios = $axios.create({
    adapter: cache.adapter,
    timeout: 5000,
  });

  //   if (!error.response) {
  //     return;
  //   }

  //   const code = error.response.status;

  //   // Unauthorized requests
  //   if (code === 400) {
  //     $sentry.captureException(`${code} :`, error.response);
  //     return;
  //   }

  //   if (code === 401) {
  //     $sentry.captureException(`${code} :`, error.response);
  //     // redirect('/login');

  //     return;
  //   }

  //   // Forbidden requests
  //   if (code === 403) {
  //     $sentry.captureException(`${code} :`, error.response);
  //     // app?.router?.back();

  //     return;
  //   }

  //   // Not found requests
  //   if (code === 404) {
  //     $sentry.captureException(`${code} :`, error.response);
  //     // TODO: redirect('/404');
  //   }
  // });

  return {
    auth: authService($axios, $cookies),
    user: userService($axios, $cookies),
    article: articleService($axios, $cookies),
    homepage: homePageService($axios, $cookies),
    profile: profileService($axios, $cookies),
    category: categoryService($axios, $cookies),
    tag: tagService($axios, $cookies),
    instagram: instagramService($axios, $cookies),
    conversation: conversationService($axios, $cookies),
    search: searchService($axios, $cookies),
    notification: notificationService($axios, $cookies),
    feedback: feedbackService($axios, $cookies),
    corporate: corporateService($axios, $cookies),
    yazio: yazioService($axios, $cookies),
    vitrin: vitrinService($axios, $cookies),
    config: configService(cachedAxios, $cookies),
    game: gameService($axios, $cookies),
    discover: discoverService($axios, $cookies),
  };
};

const repository = (ctx, inject) => {
  const serviceWithContext = createService(ctx);

  inject('service', serviceWithContext);
};

export default repository;
